import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { MessageService } from 'primeng/api';
import { TourService } from '../followups/tour.service';

@Component({
  selector: 'app-sms-test',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ButtonModule, InputTextModule, InputTextareaModule, ToastModule, MessageModule],
  providers: [MessageService],
  templateUrl: './sms-test.component.html',
  styleUrl: './sms-test.component.scss',
})
export class SmsTestComponent {
  form: FormGroup;
  isSending = false;
  result: { sid: string; status: string } | null = null;
  errorMessage: string | null = null;

  constructor(private fb: FormBuilder, private tourService: TourService) {
    this.form = this.fb.group({
      from: ['', [Validators.required]],
      to: ['', [Validators.required]],
      body: ['', [Validators.required, Validators.maxLength(1600)]],
    });
  }

  send(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSending = true;
    this.result = null;
    this.errorMessage = null;

    this.tourService.sendTestSms(this.form.value).subscribe({
      next: (res) => {
        this.result = res;
        this.isSending = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message || err?.message || 'Failed to send SMS. Check the From number is a valid Twilio number.';
        this.isSending = false;
      },
    });
  }

  get bodyLength(): number {
    return this.form.get('body')?.value?.length ?? 0;
  }
}
